// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/*######################################################################
  GESTIONE AVP
/*####################################################################*/

.avp-cms-screen-content-grafocontent {
	height: 100%;
	margin: 0;
}

.avp-cms-screen-content-grafoleft {
	position: relative;
	float: left;
	width: 33%;
	height: 100%;
	background: #ffffff;
    border-radius: 10px;
    padding: 20px;	
	overflow-y: scroll;
}

.avp-cms-screen-content-graforight {
	position: relative;
	float: right;
	width: 66%;
	height: 100%;
	/*background: #7F7F7F;*/
	background: #F2F2F2;
    border-radius: 10px;
	max-height: 900px;
    overflow-y: scroll;	
	
}

.avp-cms-screen-content-graforight canvas {
	border-radius: 10px;

}

#avp-grafo-canvas-container {
	width: 100%;
	height: 100%;
	overflow: hidden;
}

#avp-grafo-canvas {
	/*
	width: 100%;
	height: 100%;
	*/
}

#avp-grafo-zoomin-button {
	position: absolute;
	top: 0;
	right: 50px;
	width: 40px;
	/* margin-left: 10px; */
	border-radius: 8px;
	color: #000000;
}

#avp-grafo-zoomout-button {
	position: absolute;
	top: 0;
	right: 10px;
	width: 40px;
	/* margin-left: 10px; */
	border-radius: 8px;
	color: #000000;
}

.avp-gestioneavp-nodearcs-section-title {
	font-weight: 600;
}

#avp-grafo-nodetoolbar {
	position: absolute;
	z-index: 2;
	width: 146px;
	height: 48px;
	background-color: #ffffff;
	border-radius: 10px;
	padding: 5px;
}

#avp-grafo-nodetoolbar img {
	margin-left: 5px;
	margin-right: 5px;
	width: 35px;
	height: 35px;
	cursor: pointer;
}

#avp-grafo-tooltip {
	position: absolute;
	z-index: 2;
	width: auto;
	height: auto;
	padding-left: 20px;
	padding-right: 20px;
	padding-top: 5px;
	padding-left: 5px;
	background-color: #ffffff;
	border-radius: 10px;
	padding: 5px;
	border: 1px solid #AAAAAA;
}

  @media screen and (max-width: 1199px) and (min-width: 992px){
  
  }
  
  
  
  @media screen and (max-width: 991px) and (min-width: 768px){
    
  }
  
  
  
  @media screen and (max-width: 767px) and (min-width: 576px){
   
  }
  
  
  
  @media only screen and (max-width: 575px){

  }`, "",{"version":3,"sources":["webpack://./src/avp/gestione_avp.css"],"names":[],"mappings":";AACA;;uEAEuE;;AAEvE;CACC,YAAY;CACZ,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,UAAU;CACV,YAAY;CACZ,mBAAmB;IAChB,mBAAmB;IACnB,aAAa;CAChB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;IAChB,mBAAmB;CACtB,iBAAiB;IACd,kBAAkB;;AAEtB;;AAEA;CACC,mBAAmB;;AAEpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC;;;EAGC;AACF;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,WAAW;CACX,uBAAuB;CACvB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,WAAW;CACX,uBAAuB;CACvB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,YAAY;CACZ,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,iBAAiB;CACjB,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;CACZ,yBAAyB;AAC1B;;EAEE;;EAEA;;;;EAIA;;EAEA;;;;EAIA;;EAEA;;;;EAIA;;EAEA","sourcesContent":["\r\n/*######################################################################\r\n  GESTIONE AVP\r\n/*####################################################################*/\r\n\r\n.avp-cms-screen-content-grafocontent {\r\n\theight: 100%;\r\n\tmargin: 0;\r\n}\r\n\r\n.avp-cms-screen-content-grafoleft {\r\n\tposition: relative;\r\n\tfloat: left;\r\n\twidth: 33%;\r\n\theight: 100%;\r\n\tbackground: #ffffff;\r\n    border-radius: 10px;\r\n    padding: 20px;\t\r\n\toverflow-y: scroll;\r\n}\r\n\r\n.avp-cms-screen-content-graforight {\r\n\tposition: relative;\r\n\tfloat: right;\r\n\twidth: 66%;\r\n\theight: 100%;\r\n\t/*background: #7F7F7F;*/\r\n\tbackground: #F2F2F2;\r\n    border-radius: 10px;\r\n\tmax-height: 900px;\r\n    overflow-y: scroll;\t\r\n\t\r\n}\r\n\r\n.avp-cms-screen-content-graforight canvas {\r\n\tborder-radius: 10px;\r\n\r\n}\r\n\r\n#avp-grafo-canvas-container {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\toverflow: hidden;\r\n}\r\n\r\n#avp-grafo-canvas {\r\n\t/*\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\t*/\r\n}\r\n\r\n#avp-grafo-zoomin-button {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 50px;\r\n\twidth: 40px;\r\n\t/* margin-left: 10px; */\r\n\tborder-radius: 8px;\r\n\tcolor: #000000;\r\n}\r\n\r\n#avp-grafo-zoomout-button {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 10px;\r\n\twidth: 40px;\r\n\t/* margin-left: 10px; */\r\n\tborder-radius: 8px;\r\n\tcolor: #000000;\r\n}\r\n\r\n.avp-gestioneavp-nodearcs-section-title {\r\n\tfont-weight: 600;\r\n}\r\n\r\n#avp-grafo-nodetoolbar {\r\n\tposition: absolute;\r\n\tz-index: 2;\r\n\twidth: 146px;\r\n\theight: 48px;\r\n\tbackground-color: #ffffff;\r\n\tborder-radius: 10px;\r\n\tpadding: 5px;\r\n}\r\n\r\n#avp-grafo-nodetoolbar img {\r\n\tmargin-left: 5px;\r\n\tmargin-right: 5px;\r\n\twidth: 35px;\r\n\theight: 35px;\r\n\tcursor: pointer;\r\n}\r\n\r\n#avp-grafo-tooltip {\r\n\tposition: absolute;\r\n\tz-index: 2;\r\n\twidth: auto;\r\n\theight: auto;\r\n\tpadding-left: 20px;\r\n\tpadding-right: 20px;\r\n\tpadding-top: 5px;\r\n\tpadding-left: 5px;\r\n\tbackground-color: #ffffff;\r\n\tborder-radius: 10px;\r\n\tpadding: 5px;\r\n\tborder: 1px solid #AAAAAA;\r\n}\r\n\r\n  @media screen and (max-width: 1199px) and (min-width: 992px){\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  @media screen and (max-width: 991px) and (min-width: 768px){\r\n    \r\n  }\r\n  \r\n  \r\n  \r\n  @media screen and (max-width: 767px) and (min-width: 576px){\r\n   \r\n  }\r\n  \r\n  \r\n  \r\n  @media only screen and (max-width: 575px){\r\n\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
